import { PlateElement } from '@udecode/plate/react';
import styled from 'styled-components';
import 'highlight.js/styles/vs.css';
export const CodeBlockWrapper = styled(PlateElement)`
  .slate-code_block code[class*='language-'],
  .slate-code_block pre[class*='language-'] {
    direction: ltr;
    text-align: left;
    white-space: pre-wrap;
    word-spacing: normal;
    word-break: normal;

    -moz-tab-size: 2;
    -o-tab-size: 2;
    tab-size: 2;
    -webkit-hyphens: none;
    -moz-hyphens: none;
    -ms-hyphens: none;
    hyphens: none;
  }
`;
